<ul v-if="token_exists" class="navbar-nav d-flex flex-row text-xs fw-500">
  <li class="nav-item position-relative">
    <a
      class="nav-link text-dark text-sm"
      href="#cartOffcanvas"
      role="button"
      data-bs-toggle="offcanvas"
      aria-controls="cartOffcanvas"
    >
      <!-- Desktop Icon -->
      <i class="fas fa-shopping-cart fa-2x d-none d-md-inline"></i>
      <!-- Mobile Icon -->
      <i
        class="fas fa-shopping-cart shopping-cart-mobile d-inline d-md-none"
      ></i>
      <span
        v-if="cartBadgeCount > 0"
        class="count-badge badge rounded-pill bg-danger"
      >
        {{ cartBadgeCount }}
      </span>
    </a>
  </li>
</ul>

<!-- Offcanvas -->
<div
  class="offcanvas offcanvas-end"
  tabindex="-1"
  id="cartOffcanvas"
  aria-labelledby="cartOffcanvasLabel"
>
  <div class="offcanvas-header">
    <h5 class="offcanvas-title" id="cartOffcanvasLabel">Your Cart</h5>
    <button
      type="button"
      class="btn-close text-reset"
      data-bs-dismiss="offcanvas"
    ></button>
  </div>

  <div class="offcanvas-body p-2">
    <!-- Inside a business profile -->
    <div v-if="base_profile_id" class="d-flex flex-column h-100 p-2">
      <!-- Cart items -->
      <div class="flex-grow-1 overflow-auto">
        <div v-if="cartItems.items && cartItems.items.length">
          <div
            v-for="item in cartItems.items"
            :key="item.id"
            class="cart-item mb-2 border-bottom pb-2 d-flex justify-content-between align-items-center"
          >
            <!-- Left: Image + Product Name + Price -->
            <div class="d-flex align-items-center">
              <div class="cart-item-image me-2">
                <img
                  :src="item.product.images && item.product.images.length ? item.product.images[0].image_url : require('@/assets/images/no_image.png')"
                  alt="Product"
                  class="img-fluid rounded"
                />
              </div>
              <div class="d-flex flex-column">
                <p class="mb-0 fw-medium">{{ item.product.name }}</p>
                <p class="mb-0 fw-medium">{{ item.product_name }}</p>
                <small class="text-muted">R{{ format_money(item.price)  }}</small>
                <small
                  v-for="(attribute, index) in get_item_attributes(item)"
                  :key="`${item.id}-attribute-${index}`"
                  class="text-muted"
                >
                  {{ attribute.label }}: {{ attribute.value }}
                </small>
              </div>
            </div>

            <!-- Right: Quantity + Trash -->
            <div class="d-flex align-items-center mt-4 me-2">
              <button
                class="btn btn-sm btn-outline-dark p-1 hover-grow"
                @click="decreaseQuantity(item)"
              >
                <i class="fas fa-minus fa-xs cart-icons"></i>
              </button>
              <span class="px-2">{{ item.quantity }}</span>
              <button
                class="btn btn-sm btn-outline-dark me-2 p-1 hover-grow"
                @click="increaseQuantity(item)"
              >
                <i class="fas fa-plus fa-xs cart-icons"></i>
              </button>
              <button
                class="btn btn-sm btn-outline-dark p-1 hover-grow"
                @click="removeCartItem(item)"
              >
                <i class="fas fa-trash fa-xs cart-icons"></i>
              </button>
            </div>
          </div>
        </div>

        <!-- Empty state if no items -->
        <div v-else class="text-center py-4">
          <p class="text-muted mb-0">No products in this cart yet.</p>
        </div>
      </div>

      <!-- Checkout button always at the bottom -->
      <div v-if="cartItems.items" class="mt-auto border-top pt-2">
          <div class="d-flex justify-content-between">
          <span class="align-items-start">Total:</span>
          <span>R{{ format_money(cartItems.total_amount) }}</span>
          </div>
        <button class="btn btn-primary btn-sm text-xs w-100 rounded" @click="initiate_checkout(cartItems.id)">
          Checkout
        </button>
      </div>
    </div>

    <!-- Home page: multiple carts -->

    <div v-else>

      <div v-if="cartItems && cartItems.length">


      <div v-for="cart in cartItems" :key="cart.id" class="cart-company mb-4 p-2 border rounded shadow-sm">
      <p class="fw-500">{{ cart.base_profile.profile_name }}</p>
        <!-- Cart Items -->
        <div
          v-for="item in cart.items"
          :key="item.id"
          class="cart-item mb-1 border-bottom pb-2 d-flex justify-content-between align-items-center"
        >
          <!-- Left: Image + Product Name + Price -->
          <div class="d-flex align-items-center">
            <div class="cart-item-image me-2">
              <img
                :src="item?.product?.images?.length ? item.product.images[0].image_url : require('@/assets/images/no_image.png')"
                alt="Product"
                class="img-fluid rounded"
              />
            </div>
            <div class="d-flex flex-column">
              <p class="mb-0 fw-semibold text-xs">{{ item.product.name }}</p>
              <small class="text-muted text-xs">R{{ format_money(item.price) }}</small>
              <small
                v-for="(attribute, index) in get_item_attributes(item)"
                :key="`${item.id}-attribute-${index}`"
                class="text-muted text-xs"
              >
                {{ attribute.label }}: {{ attribute.value }}
              </small>
            </div>
          </div>

          <!-- Right: Quantity + Trash -->
          <div class="d-flex align-items-center mt-4">
            <button
              class="btn btn-sm btn-outline-dark p-1 hover-grow"
              @click="decreaseQuantity(item)"
            >
              <i class="fas fa-minus fa-xs cart-icons"></i>
            </button>
            <span class="px-2">{{ item.quantity }}</span>
            <button
              class="btn btn-sm btn-outline-dark me-2 p-1 hover-grow"
              @click="increaseQuantity(item)"
            >
              <i class="fas fa-plus fa-xs cart-icons"></i>
            </button>
            <button
              class="btn btn-sm btn-outline-dark p-1 hover-grow"
              @click="removeCartItem(item)"
            >
              <i class="fas fa-trash fa-xs cart-icons"></i>
            </button>
          </div>
        </div>

        <!-- Checkout per company -->
        <div class="mt-2 text-end">
          <div class="d-flex justify-content-between">
          <span class="align-items-start">Total:</span>
          <span>R{{ format_money(cart.total_amount) }}</span>
          </div>
          <button class="btn btn-primary w-100 btn-sm" @click="initiate_checkout(cart.id)">
            Checkout {{ cart.company_name }}
          </button>
        </div>
      </div>
      </div>
      <!-- Empty state if no carts -->
        <div v-else class="text-center py-4">
          <p class="text-muted mb-0">No products in this cart yet.</p>
        </div>

    </div>
  </div>
</div>
